export default __webpack_public_path__ + "static/media/landing_KOR_02.95657112.png";